import { z } from 'zod';
import { LanguageLevel } from './domain/common';
import { ValidationPatterns } from './shared';
const LanguageLevelSchema = z.enum(LanguageLevel);
const patterns = {
  mongoObjectId: ValidationPatterns.flexibleObjectId,
  languageCode: z.string().min(2).max(10),
  wordText: z.string().min(1).max(100),
  definition: z.string().max(1000),
  example: z.string().max(500),
  frequency: z.number().min(0),
  rating: z.number().min(1),
};
const BaseWordSchema = z.object({
  _id: patterns.mongoObjectId,
  word: patterns.wordText,
  lemma: patterns.wordText,
  english: patterns.wordText,
  englishLemma: patterns.wordText,
  language: patterns.languageCode,
  category: ValidationPatterns.nonEmptyString(1, 100, 'Category'),
  topic: ValidationPatterns.nonEmptyString(1, 100, 'Topic'),
  level: LanguageLevelSchema,
  definition: patterns.definition,
  example: patterns.example,
  englishDefinition: patterns.definition,
  englishExample: patterns.example,
  freq: patterns.frequency,
  rating: patterns.rating,
  createdAt: ValidationPatterns.flexibleDate,
  updatedAt: ValidationPatterns.flexibleDate,
});
export const WordSchemas = {
  full: BaseWordSchema,
  create: BaseWordSchema.omit({
    _id: true,
    createdAt: true,
    updatedAt: true,
  }),
  learned: BaseWordSchema.extend({
    dateLeaned: ValidationPatterns.flexibleDate,
  }),
} as const;
export type Word = z.infer<typeof BaseWordSchema>;
export type CreateWord = z.infer<typeof WordSchemas.create>;
export type LearnedWord = z.infer<typeof WordSchemas.learned>;
